export default __webpack_public_path__ + "static/media/fridge1-after1-768w.f87c09cb.webp";